// extracted by mini-css-extract-plugin
export default {"contentBlock":"Content_contentBlock__1aPw1"};